import { FlowConstants } from "../../rule-engine-core/Flow/Utilities/FlowConstants";
import { FlowStepSequenceType } from "../../rule-engine-core/Flow/Structure/FlowStepSequenceType";
import { FlowUtilities } from "../../rule-engine-core/Flow/Utilities/FlowUtilities";

import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { PropertyEditorColor } from "../../CommonUI/PropertyEditing/PropertyEditorColor";
import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";
import VariablePicker from "../../CommonUI/VariablePicker/VariablePicker";
import { PropertyEditorText } from "../../CommonUI/PropertyEditing/PropertyEditorText";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { ExpressionView } from "../../Expressions/ExpressionView";
import { FlowStepSequence } from "../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { Box } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export class FlowSequenceEditRenderer {
    sequence: FlowStepSequence;

    constructor(sequence: FlowStepSequence) {
        this.sequence = sequence;
    }

    renderEditUI(): JSX.Element | null {
        let isSystem: boolean =
            this.sequence._id === FlowConstants.PRIMARY_SEQUENCE ||
            this.sequence._id == FlowConstants.END_SEQUENCE ||
            this.sequence._id === FlowConstants.ERROR_SEQUENCE;

        return (
            <ObserveState
                listenTo={this.sequence}
                control={() => (
                    <>
                        {!isSystem && (
                            <>
                                Sequence Type
                                <RadioGroup
                                    value={this.sequence.sequenceType}
                                    name="sequence_type"
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        // @ts-ignore
                                        this.sequence.sequenceType = event.target.value;
                                        StateManager.changed(this.sequence);
                                    }}
                                >
                                    <FormControlLabel
                                        value={FlowStepSequenceType.STANDARD}
                                        control={<Radio />}
                                        label="Standard"
                                    />
                                    <FormControlLabel
                                        value={FlowStepSequenceType.BRANCH_MERGE}
                                        control={<Radio />}
                                        label="Branch/Merge"
                                    />
                                    <FormControlLabel
                                        value={FlowStepSequenceType.ITERATE}
                                        control={<Radio />}
                                        label="For Each Item"
                                    />
                                    <FormControlLabel
                                        value={FlowStepSequenceType.ITERATE_PARALLEL}
                                        control={<Radio />}
                                        label="For Each Item (Parallel)"
                                    />
                                    <FormControlLabel
                                        value={FlowStepSequenceType.ITERATE_WHILE}
                                        control={<Radio />}
                                        label="Repeat While"
                                    />
                                </RadioGroup>
                            </>
                        )}

                        {(this.sequence.sequenceType === FlowStepSequenceType.ITERATE ||
                            this.sequence.sequenceType === FlowStepSequenceType.ITERATE_PARALLEL) && (
                            <>
                                <VariablePicker
                                    selected={this.sequence.listArrayVariableName}
                                    data={FlowUtilities.getDataForSequence(this.sequence.flow!, this.sequence._id)}
                                    isList={true}
                                    onVariableSet={(path: string) => {
                                        if (path) {
                                            this.sequence.listArrayVariableName = path;
                                            StateManager.propertyChanged(this.sequence, "listArrayVariableName");
                                        }
                                    }}
                                    label={"List Variable"}
                                    variant={"outlined"}
                                    size={"medium"}
                                    fullWidth={true}
                                />
                                <PropertyEditorText
                                    editObject={this}
                                    propertyName={"listItemVariableName"}
                                    label={"Item Name"}
                                />
                            </>
                        )}

                        {this.sequence.sequenceType === FlowStepSequenceType.ITERATE_WHILE && (
                            // add the rule
                            <>
                                Repeat while true
                                <Box
                                    border={"1px"}
                                    borderRadius="4pxpx"
                                    style={{ borderColor: UIStyleConstants.GRAY_LIGHTER_COLOR, borderStyle: "solid" }}
                                    marginTop={"4px"}
                                >
                                    <ExpressionView expression={this.sequence.whileExpression!}></ExpressionView>
                                </Box>
                            </>
                        )}

                        <PropertyEditorColor
                            data-testid={`${this.sequence._id}_stack-color`}
                            editObject={this.sequence}
                            propertyName="color"
                            label="Stack Color"
                            sx={{ marginTop: "12px" }}
                        />
                    </>
                )}
            ></ObserveState>
        );
    }
}
